// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "service_area.proto" (syntax proto3)
// tslint:disable
import { ServiceAreaService } from "./service_area";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * The Kalos service-area boundary (ClickUp 86bbxu0gj): the polygon the dispatch
 * map outlines and Schedule Call warns against.
 *
 * Read-only by design. The boundary is edited by SQL against the service_area
 * row, so there is no Create, Update or Delete here -- any of them would imply
 * an admin UI that does not exist.
 *
 * One read, because there is only one caller: the browser needs the vertices to
 * outline the dispatch map and to warn in Schedule Call before anything is
 * saved. The Go event service does not come through here at all -- it reads the
 * row in process through PolygonCache, on a path every job booking runs.
 *
 * @generated from protobuf service ServiceAreaService
 */
export class ServiceAreaServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = ServiceAreaService.typeName;
        this.methods = ServiceAreaService.methods;
        this.options = ServiceAreaService.options;
    }
    /**
     * @generated from protobuf rpc: BatchGetServiceArea
     */
    batchGetServiceArea(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
